import type { Resource } from '../../';
export const header_utilBar_myAccount: Resource = {"default":"My Account"};
